import { render, staticRenderFns } from "./InfosCard.vue?vue&type=template&id=2bd06ec6&scoped=true&"
import script from "./InfosCard.vue?vue&type=script&lang=js&"
export * from "./InfosCard.vue?vue&type=script&lang=js&"
import style0 from "./InfosCard.vue?vue&type=style&index=0&id=2bd06ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd06ec6",
  null
  
)

export default component.exports